export type OrBadgeVariant = "normal" | "link";

export interface UseOrBadgeParams {
  className?: string;
  disabled?: boolean;
  variant?: OrBadgeVariant;
}

export interface UseOrBadgeResult {
  badgeClassName: string;
}

export function useOrBadge({
  className,
  disabled = false,
  variant = "normal",
}: UseOrBadgeParams): UseOrBadgeResult {
  const badgeClassName = ["or-badge", `or-badge--${variant}`, disabled ? "or-badge--disabled" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");

  return {
    badgeClassName,
  };
}
